// extracted by css-extract-rspack-plugin
export default {"highlight":"HighlightExpression-module__highlight___nJ32l"};